import { useEffect, useState } from "react"

export function useIsRendered(): boolean {
  const [isRendered, setIsRendered] = useState(false)

  useEffect(() => {
    setIsRendered(true)
  }, [])

  return isRendered
}
